import CommonReducer from "./Common/Reducer"
const Reducers = {
    CommonReducer,
}
export default Reducers